const validateName = (name) => {
  if (typeof name !== 'string') {
    return false
  }
  const minLength = 1
  const maxLength = 100
  const alphaRegexp = /^[A-Za-z! \D]+$/
  return !(name.length < minLength || name.length > maxLength || !alphaRegexp.test(name))
}

export default validateName
